export enum InfoBlockBehaviour {
    NoCollapse = 0,
    Accordion = 1,
    AccordionNoCollapse = 2,    
}
